import {i18n} from "../../i18n.ts"

type TLeadNameSource = {
  title: string | null
  contact: {first_name: string | null; last_name: string | null} | null
  organization: {name: string | null} | null
}

/**
 * The contact's full name, else the organisation's name, else the deal title, else a neutral placeholder;
 * null or blank parts fall through.
 */
export const leadName = (deal: TLeadNameSource): string => {
  const contactName = [deal.contact?.first_name?.trim(), deal.contact?.last_name?.trim()].filter(Boolean).join(" ")

  return (
    contactName || deal.organization?.name?.trim() || deal.title?.trim() || i18n.t("KlaraDashboard_Leads_UnnamedLead")
  )
}
